//  counter js start here
const counters = document.querySelectorAll('.counter');

counters.forEach(counter => {
  const updateCount = () => {
    const target = +counter.getAttribute('data-target');
    const current = +counter.innerText.replace(/\D/g, ''); // Remove non-digit characters
    const increment = Math.ceil(target / 100);

    if (current < target) {
      counter.innerText = `${current + increment}+`;
      setTimeout(updateCount, 20);
    } else {
      counter.innerText = `${target.toLocaleString()}+`;
    }
  };

  updateCount();
});
//  counter js end here
//  Fade Animation js start here
const animatables = document.querySelectorAll('.animate');

const animateOnScroll = () => {
  animatables.forEach((el) => {
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight - 100) {
      el.classList.add('visible');
    }
  });
};


window.addEventListener("scroll", function() {
  if (window.scrollY > 100) {
    document.querySelector("header").classList.add("header-fixed");
  } else {
    document.querySelector("header").classList.remove("header-fixed");
  }
});


window.addEventListener('scroll', animateOnScroll);
window.addEventListener('load', animateOnScroll);
//  Fade Animation js end here

// filter column toggle js start here 
function toggleSection(currentEl) {
  const allItems = document.querySelectorAll('.filter-item');

  allItems.forEach(item => {
    const section = item.querySelector('.collapse-section');
    const icon = item.querySelector('.toggle-icon');

    if (item === currentEl) {
      // Toggle current
      const isOpen = section.style.display === "block";
      section.style.display = isOpen ? "none" : "block";
      icon.textContent = isOpen ? "+" : "−";
    } else {
      // Close others
      section.style.display = "none";
      icon.textContent = "+";
    }
  });
}

// filter column toggle js end here 


// Size Button Active Toggle
document.querySelectorAll('#sizeBtns .btn').forEach(btn => {
  btn.addEventListener('click', function () {
    document.querySelectorAll('#sizeBtns .btn').forEach(b => b.classList.remove('active'));
    this.classList.add('active');
  });
});

// Quantity Control
function changeQty(val) {
  const input = document.getElementById('qty');
  let newVal = parseInt(input.value) + val;
  if (newVal >= 1) input.value = newVal;
}

// Accordion Toggle (Only one open)
document.querySelectorAll('.accordion-header').forEach(header => {
  header.addEventListener('click', function () {
    const parent = this.parentElement;
    document.querySelectorAll('.accordion-item').forEach(item => {
      if (item !== parent) item.classList.remove('active');
    });
    parent.classList.toggle('active');
  });
});


// select design js start here 
document.querySelectorAll('.design').forEach(img => {
  img.addEventListener('click', function () {
    document.querySelectorAll('.design').forEach(d => d.classList.remove('active'));
    this.classList.add('active');
  });
});

// play video js start here